import React from "react";
import { Link } from "react-router-dom";

const Header = () => (
  <header
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "60px",
      background: "white",
      textAlign: "center",
      lineHeight: "60px",
      borderBottom: "1px solid #ddd",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      zIndex: 1000,
      fontWeight: 600,
      fontSize: "1.2rem",
    }}
  >
    <Link to="/" style={{ textDecoration: "none", color: "black" }}>
      SecretSanta.gg
    </Link>
  </header>
);

export default Header;
